import { NgModule } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import { AppComponent } from './app.component'
import { CheckServerUpdateComponent } from './components/check-server-update/check-server-update.component'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { AppRoutingModule } from './app-routing.module'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { SnackbarComponent } from './components/snackbar/snackbar.component'
import {
    IgxButtonModule,
    IgxDialogModule,
    IgxGridModule,
    IgxRadioModule,
    IgxSimpleComboModule,
    IgxSnackbarModule,
    IgxTooltipModule,
    IgxTreeGridModule,
} from '@infragistics/igniteui-angular'
import { TreeGridComponent } from './components/tree-grid/tree-grid.component'
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'
import { YesNoDialogComponent } from './components/dialogs/yes-no-dialog/yes-no-dialog.component'
import { loadingCircleComponent } from './components/loading-circle/loading-circle.component'
import { footerComponent } from './components/footer/footer.component'
import { ButtonComponent } from './components/button/button.component'
import { RouterModule, Routes } from '@angular/router'
// import { SideNavMenuComponent } from './components/side-nav-menu/side-nav-menu.component'
// import { PageHeaderComponent } from './components/page-header/page-header.component'
import { SelectedFileDialogComponent } from './components/dialogs/selected-file-dialog/selected-file-dialog.component'
import { UploadDialogComponent } from './components/dialogs/upload-dialog/upload-dialog.component'
import { CreateCassetteComponent } from './views/create-cassette/create-cassette.component'
import { SelectAreaComponent } from './views/select-area/select-area.component'
import { DashboardComponent } from './views/dashboard/dashboard.component'
import { PetaboComponent } from './components/petabo/petabo.component'
import { PetaboDialogComponent } from './components/dialogs/petabo-dialog/petabo-dialog.component'
import { WBSViewerComponent } from './views/wbs-viewer/wbs-viewer.component'
// import { IsbeauthComponent } from './isbeauth/isbeauth.component'
import {
    IsIgxAppHeaderComponent,
    IsIgxDialogMessageComponent,
    IsIgxHubComponent,
    IsIgxMappingComponent,
    IsIgxWbsTreeGridComponent,
} from '@interserve/igx-angular'
import { CreateAreaComponent } from './views/create-area/create-area.component'
import { WBSItemViewerComponent } from './views/wbs-item-viewer/wbs-item-viewer.component'
import { SelectWbsItemComponent } from './views/select-wbs-item/select-wbs-item.component'
import { UpdateWbsItemComponent } from './views/update-wbs-item/update-wbs-item.component'
import { CreateAreaUserComponent } from './views/create-area-user/create-area-user.component'
import { CreateAreaOwnerComponent } from './views/create-area-owner/create-area-owner.component'
import { SelectAreaForAreauserComponent } from './views/select-area-for-areauser/select-area-for-areauser.component'
import { IsBeAuthComponent } from '@interserve/angular'

const routes: Routes = []
@NgModule({
    declarations: [
        AppComponent,
        CheckServerUpdateComponent,
        // IsbeauthComponent,
        SnackbarComponent,
        TreeGridComponent,
        YesNoDialogComponent,
        loadingCircleComponent,
        ButtonComponent,
        // PageHeaderComponent,
        footerComponent,
        // SideNavMenuComponent,
        SelectedFileDialogComponent,
        UploadDialogComponent,
        SelectAreaComponent,
        SelectWbsItemComponent,
        CreateAreaComponent,
        CreateCassetteComponent,
        DashboardComponent,
        PetaboComponent,
        PetaboDialogComponent,
        WBSViewerComponent,
        WBSItemViewerComponent,
        UpdateWbsItemComponent,
        SelectAreaForAreauserComponent,
        CreateAreaOwnerComponent,
        CreateAreaUserComponent,
    ],
    bootstrap: [AppComponent],
    imports: [
        RouterModule.forRoot(routes, { useHash: true }),
        BrowserModule,
        FormsModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        IgxSnackbarModule,
        IgxDialogModule,
        IgxGridModule,
        IgxTreeGridModule,
        IgxButtonModule,
        IgxSimpleComboModule,
        IgxTooltipModule,
        IgxRadioModule,
        IsBeAuthComponent,
        IsIgxAppHeaderComponent,
        IsIgxHubComponent,
        IsIgxMappingComponent,
        IsIgxWbsTreeGridComponent,
        IsIgxDialogMessageComponent,
    ],
    providers: [provideHttpClient(withInterceptorsFromDi())],
})
export class AppModule {}
